
import { Component, Prop, Vue } from 'vue-property-decorator';
import LabelWithValue from '../../../core/components/Indicators/LabelWithValue.vue';
import { IndicatorConfig } from '../../../tenants/types';
import { formatIndicatorValue, IndicatorValues } from '../../../core/utils/indicator-format';

/**
 * Tarjeta de indicadores. Qué indicadores se muestran, con qué etiqueta y formato lo decide el config del tenant
 * (`pages.<pagina>.indicators`); los valores vienen del modelo común (`IndicatorKey` → valor).
 */
@Component({
    components: {
        LabelWithValue
    }
})
export default class ItemIndicators extends Vue {
    @Prop({ default: () => [] }) indicators!: IndicatorConfig[];
    @Prop({ default: () => ({}) }) values!: IndicatorValues;

    formatValue(indicator: IndicatorConfig): string {
      return formatIndicatorValue(this.values ? this.values[indicator.key] : null, indicator);
    }
}
